import { Component, EventEmitter, inject, Output } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SectionService } from 'src/app/_services/section.service';
import { BaseComponent } from '../../components/base/base.component';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-section-modal',
  templateUrl: './section-modal.component.html',
  styleUrls: ['./section-modal.component.css']
})
export class SectionModalComponent extends BaseComponent {
  private readonly _sectionsService: SectionService = inject(SectionService);
  private readonly _modalRef: NzModalRef = inject(NzModalRef);

  @Output() updateSections: EventEmitter<string> = new EventEmitter();

  menus: any[] = [];
  sectionsStatus: { [key: string]: boolean } = {};

  private readonly destroy$: Subject<void> = new Subject<void>();

  constructor() {
    super();
  }

  /**
   * funzione che serve per capire se una sezione è attiva oppure no
   * @param section nome della sezione
   * @returns boolean
   */
  isSectionActive(section: string): boolean {
    return this.sectionsStatus[section];
  }

  /**
   * funzione che serve per settare se una sezione è accessibile da tutti oppure no
   * @param section nome della sezione
   * @param enabled boolean
   */
  setAccessSection(section: string, enabled: boolean) {
    this._sectionsService
      .toggleSection(section, enabled)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.responseToast('success', res.message);
          this.updateSections.emit('update');
        },
        error: (err: any) => {
          this.responseToast('error', err.error.error);
        }
      });
  }

  closeModal() {
    this._modalRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
